// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1X5HH","inputWrap":"Table_inputWrap__3LpSs","col":"Table_col__3DWU6","bmiTooltip":"Table_bmiTooltip__LAKl6"};